import {Modal} from '@forecast-it/design-system';
import React from 'react';

type GoogleOAuthErrorModalProps = {
	errorMessage: string;
	closeModal: () => void;
};

const GoogleOAuthErrorModal = ({errorMessage, closeModal}: GoogleOAuthErrorModalProps): JSX.Element => {
	return (
		<Modal onCloseModal={closeModal}>
			<Modal.Title>Google Calendar Authorization Error</Modal.Title>
			<Modal.Content>{errorMessage}</Modal.Content>
		</Modal>
	);
};

export default GoogleOAuthErrorModal;
